/* eslint-disable */
'use client';
import { useState, useRef, useEffect } from 'react';
import { Star, ListPlus, Share, MoreHorizontal } from 'lucide-react';
import styles from './ShareMenuButton.module.css';
import CreatePlaylistModal from './CreatePlaylistModal';
import { Music2 } from 'lucide-react'
import { toast } from 'react-hot-toast';
import { useSession } from 'next-auth/react';
import { Lock, Unlock } from 'lucide-react';
import ConfirmDeleteModal from './ConfirmDeleteModal';
import { Trash } from 'lucide-react';
import { Info } from 'lucide-react';
import AuthPromptModal from './AuthPromptModal';


export default function ShareMenuButton({
  item,
  type,
  onShareToggle,
  isEditing,
  onEditToggle,
  playlistId,   // 👈 добавили
  isOwner,       // 👈 добавили
  onRemoved,
  onPointerDown,   // 👈 добавили
  onClick,
}: {
  item: any;
  type: 'song' | 'work' | 'userplaylist' | 'playlist';
  onShareToggle?: (newValue: boolean) => void;
  isEditing?: boolean;
  onEditToggle?: () => void;
  playlistId?: number;
  isOwner?: boolean;
  onRemoved?: (songId: number) => void; // 👈 типизация
  onPointerDown?: (e: React.PointerEvent) => void;
  onClick?: (e: React.MouseEvent) => void;

}) {

  const [showMenu, setShowMenu] = useState(false);
  const [isFavorited, setIsFavorited] = useState(
    item.isFavorited ?? false
  );
  const [menuPosition, setMenuPosition] = useState<'left' | 'right'>('right');
  const menuRef = useRef(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [userPlaylists, setUserPlaylists] = useState<any[]>([]);
  const [showPlaylistMenu, setShowPlaylistMenu] = useState(false);
  const playlistMenuRef = useRef<HTMLDivElement | null>(null);

  //const isOwner = type === 'userplaylist' && item.ownerId === session?.user?.id;
  const [isShared, setIsShared] = useState(item.isShared);
  const [, setPlaylistMenuPosition] = useState<'left' | 'right'>('right');
  const [menuDirection, setMenuDirection] = useState<'up' | 'down'>('down');
  const [, setPlaylistMenuDirection] = useState<'up' | 'down'>('down');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { data: session } = useSession();
  const [showAuthPrompt, setShowAuthPrompt] = useState<null | { title: string; message: string }>(null);
  const toggleMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();


    const rect = e.currentTarget.getBoundingClientRect();

    // --- Горизонтальное направление ---
    const spaceRight = window.innerWidth - rect.right;
    const spaceLeft = rect.left;

    if (spaceRight >= 200 || spaceLeft < 200) {
      setMenuPosition('left');
    } else {
      setMenuPosition('right');
    }

    // --- Вертикальное направление ---
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    if (spaceBelow < 200 && spaceAbove > spaceBelow) {
      setMenuDirection('up');   // 👈 новый стейт для вертикали
    } else {
      setMenuDirection('down');
    }

    setShowMenu(prev => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const t = event.target as Node;
      const outsideMain = !menuRef.current || !menuRef.current.contains(t);
      const outsidePlaylist = !playlistMenuRef.current || !playlistMenuRef.current.contains(t);
      if (outsideMain && outsidePlaylist) {
        setShowMenu(false);
        setShowPlaylistMenu(false);
      }
    };

    if (showMenu || showPlaylistMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showMenu, showPlaylistMenu]);

  const handleToggleShare = async () => {
    try {
      const res = await fetch(`/api/userplaylist/${item.id}/share`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ isShared: !isShared }),
        credentials: 'include',
      });

      if (res.ok) {
        setIsShared(!isShared);
        toast.success(!isShared ? 'Playlist is now public. You can share it!' : 'Playlist is now private. Sharing disabled.');
        onShareToggle?.(!isShared);
      } else {
        toast.error('Failed to update sharing status');
      }
    } catch (err) {
      console.error('Share toggle failed:', err);
      toast.error('Error updating sharing status');
    }
  };
  const handleAddTrack = async (userplaylistId: number) => {
    try {
      const body =
        type === 'song'
          ? { userplaylistId, songId: item.id }
          : { userplaylistId, workId: item.id };

      const res = await fetch('/api/userplaylist/add-track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        credentials: 'include',
      });

      if (res.status === 409) {
        toast.error('This track is already in the playlist', {
          icon: <Info color="#ff756b" size={20} strokeWidth={2.5} />, // 👈 кастомная иконка вместо жёлтого ⚠️
        });
        return;
      }

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        toast.error(err.error || 'Failed to add track', {
          icon: <Info color="#ff756b" size={20} strokeWidth={2.5} />,
        });
        return;
      }

      const message =
        type === 'song'
          ? 'Track added to playlist!'
          : type === 'work'
            ? 'Work added to playlist!'
            : 'Added!';

      toast.success(message, {

      });

      setShowPlaylistMenu(false);
      setShowMenu(false);
    } catch (err) {
      console.error('Ошибка добавления трека:', err);
      toast.error('Failed to add track', {
        icon: <Info color="#ff756b" size={20} strokeWidth={2.5} />,
      });
    } finally {
      // 👇 закрываем меню в любом случае
      setShowPlaylistMenu(false);
      setShowMenu(false);
    }
  };


  const handleCreatePlaylist = async (title: string) => {
    try {
      const res = await fetch('/api/userplaylist/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ title }),
        credentials: 'include',
      });
      const newPlaylist = await res.json();
      setUserPlaylists(prev => [...prev, newPlaylist]);
      setShowCreateModal(false);

      // 👇 Автоматически добавляем трек в новый плейлист
      await handleAddTrack(newPlaylist.id);
    } catch (err) {
      console.error('Ошибка создания плейлиста:', err);
      toast.error('Failed to create playlist');
    }
  };


  const handleAddToPlaylistClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!session) {
      setShowAuthPrompt({
        title: 'You are not signed in',
        message: 'Please sign in to add tracks to your playlists.',
      });
      return;
    }
    const rect = e.currentTarget.getBoundingClientRect();

    // --- Горизонтальное направление ---
    const spaceRight = window.innerWidth - rect.right;
    const spaceLeft = rect.left;

    if (spaceRight >= 200 || spaceLeft < 200) {
      setPlaylistMenuPosition('left');
    } else {
      setPlaylistMenuPosition('right');
    }

    // --- Вертикальное направление ---
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    if (spaceBelow < 200 && spaceAbove > spaceBelow) {
      setPlaylistMenuDirection('up');   // 👈 новый стейт для вертикали
    } else {
      setPlaylistMenuDirection('down');
    }

    setShowPlaylistMenu(prev => !prev);

    // --- Загрузка плейлистов ---
    if (!userPlaylists.length) {
      try {
        const res = await fetch('/api/userplaylist/user', { credentials: 'include' });
        const data = await res.json();
        setUserPlaylists(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('Ошибка загрузки плейлистов:', err);
        setUserPlaylists([]);
      }
    }
  };



  const handleToggleFavorite = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!session) {
      setShowAuthPrompt({
        title: 'You are not signed in',
        message: 'Please sign in to manage favorites.',
      });
      return;
    }

    try {
      const body: any = {};

      if (type === 'playlist') {
        body.playlistId = item.id;
      } else if (type === 'song') {
        body.songId = item.id;
      } else if (type === 'work') {
        body.workId = item.id;
      } else if (type === 'userplaylist') {
        body.userplaylistId = item.id;
      }

      const method = isFavorited ? 'DELETE' : 'POST';

      const res = await fetch('/api/favorite', {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        credentials: 'include',
      });

      if (!res.ok) {
        throw new Error(`Favorite toggle failed: ${res.status}`);
      }

      setIsFavorited(!isFavorited);
      setShowMenu(false);

    } catch (err) {
      console.error('Favorite toggle failed:', err);
      toast.error('Failed to update favorites');
    }
  };

  const handleShare = () => {
    // ⛔ Защита от шаринга приватного пользовательского плейлиста
    if (type === 'userplaylist' && !isShared) {
      toast.error('This playlist is private. Make it public before sharing.');
      return;
    }

    if (navigator.share) {
      navigator.share({
        title: item.title,
        url: `${window.location.origin}/${type}/${item.slug}`,
      }).catch(err => console.error('Share failed:', err));
    } else {
      alert('Sharing is only supported in compatible browsers');
    }
  };

  const handleDeletePlaylist = () => {
    setShowDeleteModal(true);
    setShowMenu(false);
  };

  const confirmDelete = async () => {
    try {
      const res = await fetch(`/api/userplaylist/${item.id}`, {
        method: 'DELETE',
        credentials: 'include',
      });

      if (res.ok) {
        toast.success('Playlist deleted successfully');
        window.location.href = '/';
      } else {
        toast.error('Failed to delete playlist');
      }
    } catch (err) {
      console.error('Delete playlist failed:', err);
      toast.error('Error deleting playlist');
    }
  };

  return (
    <div className={styles.wrapper}>
      <button
        className={styles.circleButton}
        ref={menuRef}
        onPointerDown={onPointerDown}
        onClick={toggleMenu}
        aria-label="More options"
      >
        <MoreHorizontal size={20} color="#666" />
      </button>

      {showMenu && (
        <div
          className={`${styles.menu} ${menuPosition === 'left' ? styles.menuLeft : styles.menuRight} ${menuDirection === 'up' ? styles.menuUp : styles.menuDown}`}
          ref={menuRef}
        >
          {(type === 'song' || type === 'work') && (
            <button onClick={handleAddToPlaylistClick}>
              <ListPlus className={styles.icon} /> Add to Playlist
            </button>
          )}
          {showPlaylistMenu && (
            <div
              className={`${styles.playlistMenu} ${menuPosition === 'left' ? styles.menuLeft : styles.menuRight}`}
              ref={playlistMenuRef}
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onMouseDown={(e) => e.stopPropagation()}
                onClick={() => setShowCreateModal(true)}
              >
                <ListPlus size={16} /> New Playlist
              </button>

              <div
                className={styles.scrollArea}
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
              >
                {userPlaylists.map(pl => (
                  <button
                    key={pl.id}
                    className={styles.playlistItem}
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={() => handleAddTrack(pl.id)}
                  >
                    <Music2 className={styles.icon} />
                    <span className={styles.playlistTitle}>{pl.title}</span>
                  </button>
                ))}
              </div>
            </div>
          )}



          <button onClick={handleToggleFavorite}>
            <Star
              className={`${styles.icon} ${isFavorited ? styles.favorited : ''}`}
            />
            {isFavorited ? 'Remove from Favorites' : 'Add to Favorites'}
          </button>
          {/* 👇 вот здесь вставляем удаление трека из плейлиста */}
          {type === 'song' && playlistId && isOwner && (
            <button
              onClick={async (e) => {
                e.preventDefault();     // 👈 теперь e определён
                e.stopPropagation();
                setShowMenu(false);
                try {
                  const res = await fetch('/api/userplaylist/remove-track', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      userplaylistId: playlistId,
                      songId: item.id,
                    }),
                    credentials: 'include',
                  });

                  if (!res.ok) {
                    const err = await res.json().catch(() => ({}));
                    toast.error(err.error || 'Failed to remove track');
                  } else {
                    toast.success('Track removed from playlist');
                    // 👇 уведомляем родителя, чтобы убрать трек из списка
                    onRemoved?.(item.id);
                  }
                } catch (err) {
                  console.error('Ошибка удаления трека:', err);
                  toast.error('Failed to remove track');
                }
              }}
            >
              <Trash className={styles.icon} /> Remove from Playlist
            </button>
          )}
          {type === 'userplaylist' && isOwner && (
            <button
              onClick={() => {
                setShowMenu(false);
                handleToggleShare();
              }}
            >
              {isShared ? <Lock className={styles.icon} /> : <Unlock className={styles.icon} />}
              {isShared ? 'Make Private' : 'Make Public'}
            </button>
          )}

          {type === 'userplaylist' && isOwner && (
            <button
              onClick={() => {
                setShowMenu(false);
                onEditToggle?.(); // 👈 переключаем режим редактирования
              }}
            >
              <MoreHorizontal className={styles.icon} />
              {isEditing ? 'Done' : 'Edit Playlist'}
            </button>
          )}

          {type === 'userplaylist' && isOwner && (
            <button onClick={handleDeletePlaylist}>
              <Trash className={styles.icon} /> Delete Playlist
            </button>
          )}

          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleShare();
            }}
          >
            <Share className={styles.icon} /> Share
          </button>
        </div>
      )
      }
      {showAuthPrompt && (
        <AuthPromptModal
          title={showAuthPrompt.title}
          message={showAuthPrompt.message}
          onClose={() => setShowAuthPrompt(null)}
        />
      )}

      {
        showDeleteModal && (
          <ConfirmDeleteModal
            title="Delete Playlist"
            message="Are you sure you want to delete this playlist? This action cannot be undone."
            onConfirm={confirmDelete}
            onCancel={() => setShowDeleteModal(false)}
          />
        )
      }

      {
        showCreateModal && (
          <CreatePlaylistModal
            onCreate={handleCreatePlaylist}
            onClose={() => setShowCreateModal(false)}
          />
        )
      }
    </div >
  );

}
